import { Injectable } from "@angular/core";
import { AttributionService } from "../attribution/attribution.service";
import { AutresInformationsService } from "../autres-informations/autres-informations.service";
import { AvisInitialService } from "../avis-initial/avis-initial.service";
import { CriteresAttributionService } from "../criteres-attribution/criteres-attribution.service";
import { DescriptionReduiteService } from "../description-reduite/description-reduite.service";
import { ProcedureService } from "../procedure/procedure.service";

@Injectable(
    {
        providedIn: 'root'
    })
export class FormmapaServices {

    constructor(public attributionService: AttributionService, public avisInitialService: AvisInitialService,
        public descriptionReduiteService: DescriptionReduiteService, public autresInformationsService: AutresInformationsService,
        public criteresAttributionService: CriteresAttributionService, public procedureService: ProcedureService) {
    }
}
